import { Box, Flex } from '@chakra-ui/react';
import { ViewFile } from '@/components/ats';
import { useOfferStore } from '../store';
import { offerDetailsAPI } from '../api';

interface AttachmentContainerProps {
  offerId?: string | number;
  currentOffer: {
    id: string;
    attachments: any[];
  };
}

export const AttachmentContainer = ({
  currentOffer,
}: AttachmentContainerProps) => {
  const offerAttachments = useOfferStore((state) => state.offerAttachments);
  // Multi-doc renders attachments inside the doc rail, so the bottom bar would duplicate them.
  const isMultiDocTemplate = useOfferStore((state) => state.isMultiDocTemplate);

  // Seeding is owned solely by OfferBodyContainer; a second seeder here made files flicker (CORE-4803).
  const removeOfferAttachment = useOfferStore(
    (state) => state.removeOfferAttachment
  );

  const handleDelete = async (attachmentId: number) => {
    await offerDetailsAPI.deleteAttachment({
      offerId: currentOffer?.id,
      attachmentId,
    });

    removeOfferAttachment(attachmentId);
  };

  return (
    <>
      {!isMultiDocTemplate && offerAttachments?.length > 0 && (
        <Box
          minH={'70px'}
          bg="secondary-25"
          position={'fixed'}
          width={'100%'}
          bottom={'69px'}
          left={'0'}
          right={'0'}
          borderTop="1px solid"
          borderColor="border-color"
        >
          <Flex position={'relative'} p="7px" gap="6px" overflowX="auto">
            {offerAttachments?.map((item, index) => {
              if (!item?.url) return null;
              return (
                <Flex key={index}>
                  <ViewFile
                    primaryColor="secondary-700"
                    file={item}
                    showIcon={true}
                    containerProps={{ bg: '#fff' }}
                    hideTextReference={true}
                    showDownload={false}
                    showDelete={true}
                    handleDelete={() => handleDelete(item?.id)}
                    textContainerProps={{ minW: '190px' }}
                  />
                </Flex>
              );
            })}
          </Flex>
        </Box>
      )}
    </>
  );
};
